import { render, staticRenderFns } from "./RegularItem.vue?vue&type=template&id=5db7c6a8&scoped=true&"
import script from "./RegularItem.vue?vue&type=script&lang=js&"
export * from "./RegularItem.vue?vue&type=script&lang=js&"
import style0 from "./RegularItem.vue?vue&type=style&index=0&id=5db7c6a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db7c6a8",
  null
  
)

export default component.exports